// @noflow
import type { i18n } from 'i18next'
import isNull from 'lodash/isNull'
import isUndefined from 'lodash/isUndefined'
import React from 'react'
import ReactDOM from 'react-dom'

import BannerManager from '@/components/elements/molecules/BannerManager/BannerManager'

const mountBannerManagerWhenI18nReady = (event: CustomEventInit<i18n>) => {
  const bannerManagerContainer: HTMLElement | null =
    document.getElementById('banner-manager')

  if (isNull(bannerManagerContainer) || isUndefined(event.detail)) return

  ReactDOM.render(<BannerManager i18n={event.detail} />, bannerManagerContainer)

  document.removeEventListener(
    'translationInitialised',
    mountBannerManagerWhenI18nReady
  )
}

document.addEventListener('DOMContentLoaded', (): void => {
  const bannerManagerContainer: HTMLElement | null =
    document.getElementById('banner-manager')

  // Note: i18n is passed manually to BannerManager so it can be used in bundles outside of our main bundle.
  // Importing/initialising i18n directly here means our translation files will be included in the final bundle,
  // bloating its size.
  // This setup can be revisited when we transition to webpack from webpacker as it seems to be a tree shaking issue
  if (bannerManagerContainer) {
    document.addEventListener(
      'translationInitialised',
      mountBannerManagerWhenI18nReady
    )
  }
})
